import CommonPayViaModalContent from "./CommonPayViaModalContent";
import { Drawer } from "@mui/material";

function SelectPayViaModal({
  isPayViaOpen,
  setIsPayViaOpen,
  paymentMethods,
  ...props
}) {
  const commonContent = {
    setIsPayViaOpen,
    paymentMethods,
    ...props,
  };

  return (
    <Drawer
      anchor="bottom"
      open={isPayViaOpen}
      onClose={() => setIsPayViaOpen(false)}
      PaperProps={{
        sx: {
          margin: "auto",
          width: "600px",
        },
      }}
      sx={{ zIndex: 1300 }}
    >
      <CommonPayViaModalContent {...commonContent} />
    </Drawer>
  );
}

export default SelectPayViaModal;
